import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {syncHistoryWithStore} from 'react-router-redux';
import {Router, Route, browserHistory} from 'react-router';
import store from 'store';
import ShareResourceController from '../components/ShareResourceController';
import KitDocumentationController from '../components/KitDocumentationController';
import KitDocumentationIconsController from '../components/KitDocumentationIconsController';
import KitDocumentationTypefacesController from '../components/KitDocumentationTypefacesController';
import KitDocumentationImagesController from '../components/KitDocumentationImagesController';

const ShareResourceIntegrator = createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
  },

  childContextTypes: {
    kitToken: PropTypes.string,
  },

  getChildContext() {
    return {
      kitToken: this.props.kitToken,
    };
  },

  render() {
    return (
      <Provider store={store}>
        <Router history={syncHistoryWithStore(browserHistory, store)}>
          <Route path="/share/:token" component={ShareResourceController}>
            <Route path="kit-documentation" component={KitDocumentationController} />
            <Route path="kit-documentation/icons" component={KitDocumentationIconsController} />
            <Route path="kit-documentation/typefaces" component={KitDocumentationTypefacesController} />
            <Route path="kit-documentation/images" component={KitDocumentationImagesController} />
          </Route>
        </Router>
      </Provider>
    );
  },
});

export default (props) => {
  /* eslint-disable react/prop-types */
  const kitToken = props.kit;
  /* eslint-enable react/prop-types */

  return <ShareResourceIntegrator kitToken={kitToken} />;
};



// WEBPACK FOOTER //
// ./app/javascript/views/ShareResource/integrators/ShareResourceIntegrator.js